import axios from 'axios'

// Uncomment following imports if you need to transform request/response keys.
// import camelcaseKeys from 'camelcase-keys-deep'
// import snakecaseKeys from 'snakecase-keys'
// import Qs from 'qs'

const MIME_JSON = 'application/json'

function securedAxios() {
  const securedAxiosInstance = axios.create({
    withCredentials: false,
    headers: {
      Accept: MIME_JSON,
      'Content-Type': MIME_JSON
    }
  })

  const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  securedAxiosInstance.defaults.headers.common['X-CSRF-Token'] = csrf

  // Uncomment following lines if you need to apply global transform request/response keys logic.
  // I highly recommend to avoid using global transform request/response keys logic because it can produce unexpected
  // side effects.
  //
  // securedAxiosInstance.defaults.transformResponse = [(data, headers) => {
  //   if (data && headers && (headers['Content-Type'] + headers['content-type']).toString().includes(MIME_JSON)) {
  //     return camelCaseKeys(JSON.parse(data), { deep: true })
  //   }
  //   return data
  // }]
  //
  // securedAxiosInstance.defaults.transformRequest = [(data, headers) => {
  //   if (data && headers && typeof headers['Content-Type'] === 'string' && headers['Content-Type'].includes(JSON_TYPE)) {
  //     return JSON.stringify(snakeCaseKeys(data, { deep: true }))
  //   }
  //   return data
  // }]
  //
  // securedAxiosInstance.defaults.paramsSerializer = (params) => Qs.stringify(snakeCaseKeys(params, { deep: true }), { arrayFormat: 'brackets' })

  return securedAxiosInstance
}

export default securedAxios
